import React, { Component } from 'react';
import { Header, Footer } from '../layouts/home01/index';
import BookDetailsContent from '../layouts/bookdetails/BookDetailsContent';

class BookDetails extends Component {
    render() {
        return (
            <div className="bg-home1">       
                <Header />       
                <BookDetailsContent />
                <Footer />
            </div>
        );
    }
}

export default BookDetails;
